module.exports = __webpack_public_path__ + "media/drop_off_bookings/success_drop_off_bookings-5f1f9d07.png";